import gql from 'graphql-tag';
import { EventMetadata, EventSchema } from '../../definitions/schemas';
import { UserActivityEvent } from '../../enums/UserActivity';
import Interface from '../Interface';
import { eventFields } from './EventFields';

interface CreateEventInput {
  event: UserActivityEvent;
  meta?: EventMetadata;
}

interface SearchEventsInput {
  event: UserActivityEvent[];
  fromCreatedAt?: number | null;
  meta?: EventMetadata;
  toCreatedAt?: number | null;
  userId?: string[];
}

interface SearchEventsData {
  events: EventSchema[];
}

export default class EventsInterface extends Interface {
  public async create(input: CreateEventInput) {
    return this.mutate<null>(async () => {
      const response = await this.apolloService.executeMutation({
        mutation: gql`
          mutation trackEvent($input: TrackEventInput!) {
            trackEvent(input: $input) {
              errors
              trackId
            }
          }
        `,
        variables: {
          input,
        },
      });

      const { errors, message } = response.data.trackEvent;

      return {
        data: null,
        serverErrors: errors,
        serverMessage: message,
      };
    }, 'Error creating event');
  }

  public async search(variables: SearchEventsInput, fields = eventFields) {
    const response = await this.query<SearchEventsData>(
      () =>
        this.apolloService.executeQuery<SearchEventsData>({
          query: gql`
            query events(
              $event: [EventEnum!]
              $userId: [ID!]
              $fromCreatedAt: Int
              $toCreatedAt: Int
              $meta: JSON
            ) {
              events(
                event: $event
                userId: $userId
                fromCreatedAt: $fromCreatedAt
                toCreatedAt: $toCreatedAt
                meta: $meta
              ) {
                ${fields}
              }
            }
          `,
          variables,
        }),
      'Error getting events'
    );

    return response.events;
  }
}
